import { z } from 'zod';
/**
 * CrowdFPL rating data starts in FPL season 2025/26 from GW20.
 * Earlier seasons / GWs had no product data — exclude from public season/GW lists and season aggregates.
 */
export const CROWDFPL_DATA_MIN_SEASON_START_YEAR = 2025;
/** Min GW number for the launch season (start_year === 2025). Later seasons: no floor. */
export const CROWDFPL_LAUNCH_SEASON_MIN_GAMEWEEK = 20;
export function isCrowdfplDataSeason(startYear) {
    return startYear >= CROWDFPL_DATA_MIN_SEASON_START_YEAR;
}
export function crowdfplMinGameweekForSeason(startYear) {
    if (startYear === CROWDFPL_DATA_MIN_SEASON_START_YEAR) {
        return CROWDFPL_LAUNCH_SEASON_MIN_GAMEWEEK;
    }
    return 1;
}
export const seasonEntitySchema = z.object({
    id: z.string().uuid(),
    start_year: z.number().int(),
    name: z.string(),
    is_current: z.boolean(),
    start_date: z.string().nullable().optional(),
    end_date: z.string().nullable().optional(),
    created_at: z.string(),
    updated_at: z.string(),
});
